"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formWrapper = require("../../../../reducers/formWrapper.js");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdValidator = _interopRequireDefault(require("cccisd-validator"));
var _style = _interopRequireDefault(require("./style.css"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var JsonArray = function JsonArray(props) {
  var label = props.displaySettings.label;
  var originalValue = props.field.value;
  var inputEl = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  (0, _react.useEffect)(function () {
    var initialValue = props.row[props.graphqlSettings.edit.valuePath];
    if (!initialValue) {
      initialValue = '[]';
    }
    props.changeAllFields(initialValue, {
      field: props.field,
      fieldTypes: props.fieldTypes,
      operation: props.operation,
      requiredByFields: props.requiredByFields
    });
  }, []);
  if (!originalValue) {
    originalValue = '[]';
  }
  var parsedValues = JSON.parse(originalValue);
  function handleClickAdd() {
    var newInputValue = inputEl.current.value;
    var validationSettings = _objectSpread({}, props.validationSettings);
    if (!validationSettings.types || !Array.isArray(validationSettings.types)) {
      validationSettings.types = validationSettings.validationType ? [validationSettings.validationType] : [];
    }
    var isValid = (0, _cccisdValidator["default"])(newInputValue, validationSettings);
    if (isValid.status === 'fail') {
      setErrorMessage(isValid.errors[Object.keys(isValid.errors)[0]]);
      return;
    }
    setErrorMessage('');

    // convert to array just to use .push
    var previousValues = props.field.value;
    var previousValuesArray = JSON.parse(previousValues);
    if (previousValuesArray.includes(newInputValue)) {
      setErrorMessage('This value is already entered.');
    } else {
      previousValuesArray.push(newInputValue);
    }

    // convert back to string before saving
    props.changeAllFields(JSON.stringify(previousValuesArray), {
      field: props.field,
      fieldTypes: props.fieldTypes,
      operation: props.operation,
      requiredByFields: props.requiredByFields
    });

    // reset input element back to empty
    inputEl.current.value = '';
  }
  function removeItem(index) {
    var oldValues = props.field.value;
    var oldValuesArray = JSON.parse(oldValues);
    var newValues = oldValuesArray.filter(function (val, i) {
      return i !== index;
    });
    props.changeAllFields(JSON.stringify(newValues), {
      field: props.field,
      fieldTypes: props.fieldTypes,
      operation: props.operation,
      requiredByFields: props.requiredByFields
    });
  }
  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleClickAdd();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: props.field,
    label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label, ' ', props.displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: props.displaySettings.toolTip
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary"
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: _style["default"].list
  }, parsedValues && parsedValues.map(function (val, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _style["default"]["delete"],
      type: "button",
      onClick: function onClick() {
        return removeItem(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), val);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6 g-0"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: "form-control ",
    "aria-label": label,
    ref: inputEl,
    onKeyPress: handleKeyPress
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary col-2",
    type: "button",
    onClick: handleClickAdd
  }, "Add"))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-danger"
  }, errorMessage));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    reduxForm: state.form
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields
})(JsonArray);